import { __read } from "tslib";
import * as React from 'react';
import * as common from 'file-uploader-component';
export * from 'file-uploader-component';
/**
 * @public
 */
export function FileUploader(props) {
    var _a = __read(React.useState([]), 2), requests = _a[0], setRequest = _a[1];
    var locale = common.getLocale(props.locale);
    var fileGotCallback = function (file) {
        if (props.fileGot) {
            props.fileGot(file);
        }
    };
    var fileUploadedCallback = function (request) {
        if (props.fileUploaded) {
            props.fileUploaded(request.response);
        }
        common.removeRequest(requests, request);
        setRequest(requests);
    };
    var onDrop = function (e) {
        common.onDrop(e, props.name, props.url, props.method, fileGotCallback, fileUploadedCallback, function (percent) {
            setRequest(requests);
        }, function (request) {
            requests.push(request);
        });
    };
    var onPaste = function (e) {
        common.onPaste(e, props.name, props.url, props.method, fileGotCallback, fileUploadedCallback, function (percent) {
            setRequest(requests);
        }, function (request) {
            requests.push(request);
        });
    };
    var onFileUploaded = function (e) {
        common.onFileUploaded(e, props.name, props.url, props.method, fileGotCallback, fileUploadedCallback, function (percent) {
            setRequest(requests);
        }, function (request) {
            requests.push(request);
        });
    };
    var progress = requests.map(function (request, i) { return (React.createElement("div", { className: 'file-uploader-progress', title: request.file.name, key: i },
        React.createElement("div", { style: { width: request.percent + '%' } },
            request.percent,
            "%"))); });
    return (React.createElement("div", { onDrop: function (e) { onDrop(e); }, onPaste: function (e) { onPaste(e); } },
        progress,
        React.createElement("p", { className: 'file-uploader-container' },
            locale.dragAndDrop,
            React.createElement("span", null, locale.selectFile),
            locale.pasteFromClipboard,
            React.createElement("input", { type: 'file', multiple: props.multiple, accept: props.accept, onChange: function (e) { onFileUploaded(e); } }))));
}
